import type { CalendarGroup } from 'owa-graph-schema';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import { getCalendarGroupKey } from 'owa-calendar-cache';
import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import { logUsage } from 'owa-analytics';
import { mutatorAction } from 'satcheljs';

export const toggleCondenseCalendarAccount = mutatorAction(
    'toggleCondenseAccount',
    (
        calendarGroups: CalendarGroup[],
        scenarioId: CalendarPickerScenarioId,
        userIdentity: string,
        source: string
    ) => {
        if (userIdentity) {
            let showAll = true;
            const store = getCalendarPickerStore(scenarioId);
            if (store.condensedCalendarAccounts.has(userIdentity)) {
                // Expand all groups within account
                calendarGroups.map(calendarGroup => {
                    if (calendarGroup.calendarGroupId.mailboxInfo.userIdentity === userIdentity) {
                        store.collapsedCalendarGroups.delete(
                            getCalendarGroupKey(userIdentity, calendarGroup.calendarGroupId.id)
                        );
                    }
                });
                store.condensedCalendarAccounts.delete(userIdentity);
            } else {
                store.condensedCalendarAccounts.set(userIdentity, true);
                showAll = false;
            }

            logUsage('showAllToggleForAccount', { showAll_1: showAll, source_2: source });
        }
    }
);

export const condenseCalendarAccount = mutatorAction(
    'condenseCalendarAccount',
    (scenarioId: CalendarPickerScenarioId, userIdentity: string) => {
        const store = getCalendarPickerStore(scenarioId);
        if (!store.condensedCalendarAccounts.has(userIdentity)) {
            store.condensedCalendarAccounts.set(userIdentity, true);
        }
    }
);
